/**
 * walleu-video-text
 * <walleu-video-text> — tap-to-play vertical video beside text content.
 * The frame toggles play/pause on click and reflects state through the
 * `is-playing` class (the overlay button fades out via CSS). With
 * data-autoplay, an IntersectionObserver plays the video muted while ~60%
 * visible and pauses it when it leaves the viewport.
 */
(function () {
  if (window.customElements.get('walleu-video-text')) return;

  class WalleuVideoText extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.frame = this.querySelector('[data-frame]');
      if (!this.video || !this.frame) return;

      this.togglePlay = this.togglePlay.bind(this);
      if (!this.video.controls) {
        this.frame.addEventListener('click', this.togglePlay);
      }

      this.video.addEventListener('play', () => this.frame.classList.add('is-playing'));
      this.video.addEventListener('pause', () => this.frame.classList.remove('is-playing'));

      if (this.hasAttribute('data-autoplay')) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.video.muted = true;
                this.video.play().catch(() => {});
              } else {
                this.video.pause();
              }
            });
          },
          { threshold: 0.6 }
        );
        this.observer.observe(this.frame);
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    togglePlay() {
      if (this.video.paused || this.video.ended) {
        this.video.play().catch(() => {});
      } else {
        this.video.pause();
      }
    }
  }

  customElements.define('walleu-video-text', WalleuVideoText);
})();
